(function ($) {
  headerNavRowV1 = {
    formatter: $('.header-nav-row-v1')
  };

  Drupal.behaviors.headerNavRowV1 = {
    get: function (key) {
      return headerNavRowV1[key];
    },

    set: function (key, val) {
      headerNavRowV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
      });
    }
  };
})(jQuery);
